import { render, staticRenderFns } from "./shortVideoClassification.vue?vue&type=template&id=17f0b3e2&scoped=true&"
import script from "./shortVideoClassification.vue?vue&type=script&lang=js&"
export * from "./shortVideoClassification.vue?vue&type=script&lang=js&"
import style0 from "./shortVideoClassification.vue?vue&type=style&index=0&id=17f0b3e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f0b3e2",
  null
  
)

export default component.exports